import AppHeader from "../../AppHeader/AppHeader";

export default function NoMenuLayout({ children }) {
  return (
    <>
      <div className="top-bar no-menu">
        <AppHeader />
      </div>
      <div className="content no-menu">{children}</div>
    </>
  );
}
